import { Injectable } from '@angular/core';
import { ClientCurrentUser } from '../../../auth/data-model/models/client-current-user.model';
import { ServiceLocation } from '../../../crash-report/data-model/models/service-location.model';
import { LocalStorageConstants } from '../../constants/local-storage.constants';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  // setters
  setApiToken(apiToken: string): void {
    localStorage.setItem(LocalStorageConstants.API_TOKEN_KEY, apiToken);
  }
  setUser(user: ClientCurrentUser): void {
    localStorage.setItem(LocalStorageConstants.USER_KEY, JSON.stringify(user));
  }
  setServiceLocation(serviceLocation: ServiceLocation): void {
    localStorage.setItem(LocalStorageConstants.SERVICE_LOCATION_KEY, JSON.stringify(serviceLocation));
  }

  // clear-ers
  clearApiToken(): void {
    localStorage.removeItem(LocalStorageConstants.API_TOKEN_KEY);
  }
  clearUser(): void {
    localStorage.removeItem(LocalStorageConstants.USER_KEY);
  }
  clearServiceLocation(): void {
    localStorage.removeItem(LocalStorageConstants.SERVICE_LOCATION_KEY);
  }

  // getters
  getApiToken(): string | null {
    return localStorage.getItem(LocalStorageConstants.API_TOKEN_KEY);
  }
  getUser(): string | null {
    return localStorage.getItem(LocalStorageConstants.USER_KEY);
  }
  getServiceLocation(): string | null {
    return localStorage.getItem(LocalStorageConstants.SERVICE_LOCATION_KEY);
  }
}
